import type { Brand } from "@borealis/layout-express";

export const isFinn = (brand: Brand) => {
  return brand.toLowerCase() === "finn";
};
